export const Status = {
  SUCCESS: 'Success',
  IN_PROGRESS: 'In Progress',
  FAILED: 'Failed'
};